<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">私がノートよりもエクイティでの出資を好む理由</h1>
                <span class="meta"> Posted in December 2021 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/equityrounds.png" alt="">
                </figure>

                
                <p>私が過去に行った10件の投資のうち、2件を除いてすべてストレートエクイティの形をとっている。さらに、過去2年間に Shizen Capital がリードインベスターを務めた案件も、すべてエクイティラウンドに関するものだった。この記事では、私がアーリーステージのベンチャー投資において、コンバーチブルノートや SAFE ノートよりもエクイティラウンドを好む理由を説明する。</p>

                <p>ここでは話わかりやすくするために、一定の条件に基づいて将来的にスタートアップの株式に転換可能な、あらゆる種類の非株式金融商品を包括する一般的な「ノート」という用語を使用する。これには、従来のコンバーチブルノートに加え、SAFE ノートや J-KISS ノートも含まれる（SAFE ノートや J-KISS ノートは、一般的に金利や満期がないという点で、負債というよりもワラントに近い挙動をする）。</p>

                <p>私は、Shizen Capital が創業者とパートナーシップを組む際に大切にしている2つの原則、すなわち「整合性」と「透明性」に基づいて、ノートではなく株式での投資を希望している。</p>

                <p>まず、なぜノートが株式投資よりも魅力的に見えるのか、その理由を再確認しよう。</p>

                  <ol>
                    <li> 法的な観点から見て、コストがかからず、実行しやすい。</li>
                    <li> バリュエーションに関する難しい交渉を避けることができる。</li>
                    <li> 内部ラウンドの間、投資家の利益相反を回避できる。</li>
                    <li> 資金調達において、投資家にオプション権と優先権を与えることができる。</li>
                  </ol>
                </p>
        
                <p>では、これらの特徴を一つずつ説明していこう。</p>

                <p>ノート契約は、投資家（ノートホルダー）とスタートアップという2つの当事者間の契約だ。将来のある時点で、契約書に定められた条件に基づいて、ノートが株式に変換されるか、または償還される。</p>

                <p>ノートファイナンスでは株式が発行されないため、会社の手続きや法的届出は不要だ。定款の更新、株主間契約書の作成、正式な届出などは必要無い。投資家は、このような取引のために弁護士を雇う必要がないため、手数料を節約することができる（創業者も同様にこれを行うことができるが、個人的には創業者には少なくとも最低限の法律顧問を求めることをお勧めする）。しかし、将来的に希望するエクイティラウンドが実現すれば、前述の法的手続きがすべて必要になる。</p>

                <h2 class="section-heading">SAFE ノートはスピード感があるが、それは投資家の動きが速い場合に限られる</h2>

                <p>理論的には、ノートを使った取引（ここでも SAFE や J-KISS の取引を含む）は、エクイティラウンドよりも迅速に実施できる。理論上は。手際よく処理すれば、簡単な株式投資は数週間で実行できる。対照的に、ノートは数日で実施することができる（特に SAFE や J-KISS は標準的なテンプレートに基づいているため早く進められる）。しかし、ノートを使った資金調達が数週間から数カ月も長引いていると嘆く創業者の声を聞くと、私は歯がゆい思いをする。科学的な分析をしたわけではないが、私の観察によれば、シリコンバレー以外の多くの地域では、数週間から数ヶ月に及ぶノートによる話し合いは珍しくないようだ。 </p>

                <h2 class="section-heading">気まずい会話の先送り</h2>

                <p>バリュエーションに関する難しい交渉を回避できることも、ノートによる資金調達の魅力だ。ノートによる資金調達では、取引時に会社の株式に価格を付けない。資金調達時に創業者と投資家が評価額で合意できない場合、ノートは価格に関する不快な会話を先送りしてくれる。</p>
                
                <p>ここでは、コンバーチブルノートと SAFE ノートの違いが関係してくる。コンバーチブルノートでは評価額についての言及がないことが多いのだが、SAFE ノートではその構造上、評価額の上限が設定されているのが一般的だ。この評価額上限は、その時点での会社の評価を表すものではないが、当事者間の交渉による合意が必要であり、また、市場に対する将来のシグナリングの基礎となるものでもある。</p>

                <h2 class="section-heading">透明性</h2>

                <p>さらに、ここで透明性の原則が登場する。不快なバリュエーションの会話を先延ばしにすることは、単に問題を先送りすることになる。最終的には、この会話は行われなければならず、将来は今日よりもはるかに高いリスクを伴うことになるだろう。さらに、このような方法では、多くの予期せぬ結果が生じる可能性がある。私は長年にわたり、多くの企業でこのような状況を目の当たりにしたが、多くの場合、創業者に不利益をもたらしてきたため、透明性の精神に基づき、私が目撃したことを創業者に警告する義務があると考えている（注：この問題については、<a href="https://thebridge.jp/2019/04/rudevc-a-safe-note-simulation">以前書いた記事</a>で詳細に警鐘を鳴らしている）。</p>

                <h2 class="section-heading">内部ラウンド</h2>

                <p>ほとんどのプロの VC ファンドにとって、内部ラウンドは適切に行われなければコンプライアンス上の問題を引き起こす可能性がある。誤解のないように言っておくと、内部ラウンドとは、外部の重要な関係者が投資していないスタートアップの将来の資金調達ラウンドを意味する。外部の市場参加者がいない既存の投資先企業の1社をリファイナンスする VC ファンドは、新しいラウンドが株式で価格設定された場合、その後の評価を正当化する必要があり、本質的な利益相反を反映している。コンバーチブルノート（このような場合、コンバーチブルブリッジローンとして構成されることが多い）を採用することで、この問題を克服することができる。</p>

                <h2 class="section-heading">ミスアライメントのリスク</h2>

                <p>最後に、ノートによる資金調達は、当然ながら投資家に追加のオプション権を与え、資金調達における優先権をもたせる可能性がある。</p>

                <p>まず、優先権の概念から始めよう（この仕組みは、SAFE や J-KISS ノートよりもコンバーチブルノートの方が顕著だ）。投資家の観点からすると、投資先企業の全株主よりも上位に位置することで、両方のメリットを享受することができる。そのメリットとは、うまくいった場合には転換してアップサイドを享受し、うまくいかなかった場合には、企業が財務的に窮地に陥ったとしても、償還してお金と利息を得ることができるというものだ。したがって、コンバーチブルノートの契約条件は重要だ。コンバーチブルノートを発行する前に、その内容を確認する必要がある。</p>

                <p>オプション権という概念は、もう少し微妙なものだ。ベンチャーキャピタリストとして、私はオプション権を歓迎しており、実際、健全なポートフォリオ管理のために積極的にオプション権を求めている。しかし、私が投資した創業者には、ノートの意味を十分に理解してもらいたいと思っている。</p>

                <p>例えば、VC がシードラウンドで5,000万円を20％の割引と4億円のバリュエーションキャップを含む SAFE ノートで投資する場合を考えてみよう。シリーズ A の時期になると、投資家と創業者のそれぞれの利益は、わずかなずれのために発散する。創業者の直近のインセンティブは、シリーズ A の評価額を高くすることであり、できれば割引を相殺するのに十分な高さ、つまり5億円以上にしたいと考えている。</p>

                <p>一方、投資家のインセンティブは、シリーズ A の評価額が低ければ低いほど、投資家のノートが転換される株式数が多くなるため、評価額を低くすることにある。もし、シードラウンドがノートではなく、評価額が確定したエクイティラウンドとして調達されていたら、創業者と投資家の両者は、将来のシリーズ A で直面する希薄化問題にについて意見を一致していただろう。</p>

                <p>私はノートで投資することにイデオロギー的に反対しているわけではない。Shizen Capital では、すべての有望な投資を長期的な関係としてとらえている。したがって、私たちが支援する創業者とインセンティブを調整し、透明性を持って行動することができれば、両者間の共同パートナーシップはより健全で実りあるものになると信じている。 </p>


              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
li,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
